import React from "react";

// Go2Alanya brand logo: a Mediterranean sun rising over stylised waves.
export const LogoMark = ({ className = "h-9 w-9" }) => (
  <svg viewBox="0 0 40 40" className={className} role="img" aria-label="Go2Alanya">
    <defs>
      <linearGradient id="g2a-bg" x1="0" y1="0" x2="1" y2="1">
        <stop offset="0" stopColor="#0A73FF" />
        <stop offset="1" stopColor="#0043AD" />
      </linearGradient>
      <linearGradient id="g2a-sun" x1="0" y1="0" x2="1" y2="1">
        <stop offset="0" stopColor="#FF8A5B" />
        <stop offset="1" stopColor="#FF4D2E" />
      </linearGradient>
    </defs>
    <rect x="0" y="0" width="40" height="40" rx="12" fill="url(#g2a-bg)" />
    {/* sun */}
    <circle cx="26.5" cy="14.5" r="5.5" fill="url(#g2a-sun)" />
    {/* sun ray reflection */}
    <circle cx="26.5" cy="14.5" r="8.5" fill="none" stroke="#FF7A4D" strokeOpacity="0.35" strokeWidth="1.4" />
    {/* waves */}
    <path d="M6 26.5 q3.5 3 7 0 t7 0 t7 0 t4 0" fill="none" stroke="#FFFFFF" strokeWidth="2.4" strokeLinecap="round" />
    <path d="M6 31.5 q3.5 3 7 0 t7 0 t7 0 t4 0" fill="none" stroke="#9EC5FF" strokeWidth="2.2" strokeLinecap="round" />
  </svg>
);

export const Logo = ({ size = "md", className = "" }) => {
  const mark = size === "sm" ? "h-8 w-8" : "h-9 w-9";
  const text = size === "sm" ? "text-lg" : "text-xl";
  return (
    <span className={`flex items-center gap-2 ${className}`}>
      <LogoMark className={mark} />
      <span className={`font-display font-extrabold tracking-tight leading-none ${text}`}>
        Go<span className="text-accent">2</span>Alanya
      </span>
    </span>
  );
};
